import env from '../env';

import DEFAULT_IMAGE_SMALL from 'public/static/images/default/play_default_224x126.jpg';
import DEFAULT_IMAGE_MEDIUM from 'public/static/images/default/play_default_480x270.jpg';
import DEFAULT_IMAGE_LARGE from 'public/static/images/default/play_default_650x365.jpg';

export { DEFAULT_IMAGE_SMALL, DEFAULT_IMAGE_MEDIUM, DEFAULT_IMAGE_LARGE };

export function formatUrl(urlTemplate, format) {
    try {
        return urlTemplate.replace('{format}', format);
    } catch (err) {
        return DEFAULT_IMAGE_SMALL;
    }
}

export function createTemplate(imageUrl) {
    return imageUrl
        ? imageUrl.replace(/^http:/, 'https:').replace(/ALTERNATES\/.*\//, 'ALTERNATES/{format}/')
        : undefined;
}

export function isImageProxyTemplate(urlTemplate) {
    if (!urlTemplate) {
        return false;
    }

    return urlTemplate.startsWith(`${getBaseUrl()}{type}/{size}/`);
}

export function formatImageProxyUrl(urlTemplate, type, size, extras = '') {
    try {
        return urlTemplate
            .replace('{type}', type)
            .replace('{size}', size)
            .replace('{extras}', extras ? '&' + extras : '');
    } catch (err) {
        return DEFAULT_IMAGE_SMALL;
    }
}

export function createImageProxyTemplate(id, timestamp) {
    let timestampPart = timestamp ? `/${timestamp}` : '';
    let proxyURL = `${getBaseUrl()}{type}/{size}/${id}${timestampPart}?format=auto&chromaSubSampling=false`;

    return `${proxyURL}{extras}`;
}

export function createImageProxyUrl(id, timestamp, type, size, extras) {
    return formatImageProxyUrl(createImageProxyTemplate(id, timestamp), type, size, extras);
}

export function contentoImageUrl(image, type, size, fallback, extras) {
    if (!image) {
        return fallback;
    }

    return createImageProxyUrl(image.id, image.changed, type, size, extras);
}

function getBaseUrl() {
    if (env.IMAGE_ENV === 'stage') {
        return 'https://www.svtstatic.se/image-stage/';
    }

    return 'https://www.svtstatic.se/image/';
}
